import { BrowserModule } from '@angular/platform-browser';
//import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ErrorHandler, NgModule } from '@angular/core';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';
import { MyApp } from './app.component';
import { HomePage } from '../pages/home/home';
//import { ItemDetailComponent } from '../components/item-detail/item-detail';
import {HttpModule, Http} from '@angular/http';
import { AnimationService, AnimatesDirective } from 'css-animator';
import { ServiceProvider } from '../providers/service/service';


@NgModule({
  declarations: [
    MyApp,
//    HomePage,
  //  ItemDetailComponent,
    AnimatesDirective
  ],
  imports: [
    BrowserModule,
    HttpModule,
    IonicModule.forRoot(MyApp,{
    backButtonText: '返回',
    preloadModules: true,
    mode:'ios',
  //    links: [
  //      { component: HomePage,segment: 'home', name: 'home' },
  // //     { component: ItemDetailComponent,segment: 'deck', name: 'deck' },
  //     ]

  }, 
{
  links: [
    { loadChildren: '../components/item-detail/item-detail.module#ItemDetailComponentModule', name: 'deck-detail', segment: 'deck/:folder/:item/:position', priority: 'low', defaultHistory: ['home'] },
    { loadChildren: '../pages/home/home.module#HomePageModule', name: 'home', segment: 'home', priority: 'low', defaultHistory: [] }
  ]
})

  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
//    HomePage,
  //  ItemDetailComponent,
  ],
  providers: [
    {provide: ErrorHandler, useClass: IonicErrorHandler},
     AnimationService,
    ServiceProvider
  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts